import { Capacitor } from "@capacitor/core";

/**
 * За reverse-proxy Spring часто отдаёт streamUrl с http://; WebView / натив на iOS
 * не грузит http с https-приложения (ATS / mixed content).
 */
export function normalizeReleaseStreamUrl(url: string): string {
  if (!url) return url;
  if (!Capacitor.isNativePlatform()) return url;
  try {
    const apiBase = process.env.VUE_APP_API_URL || "";
    if (!apiBase) return url;
    const apiUrl = new URL(apiBase);
    const u = new URL(url);
    if (
      apiUrl.protocol === "https:" &&
      u.protocol === "http:" &&
      apiUrl.hostname === u.hostname
    ) {
      u.protocol = "https:";
      return u.toString();
    }
  } catch {
    /* ignore */
  }
  return url;
}
